<template>
    <div class="tc-select-case-category-label"
         :id="categoryId">
        <div class="tc-select-case-category-label-bold">
            {{categoryName}}
        </div>
        <div class="tc-select-case-category-label-normal">
            {{categoryDescription}}
        </div>
    </div>

    <div class="tc-select-case-cards">
        <SelectCaseCard v-for="item in casesByCategory"
                        :item="item"/>
    </div>
</template>

<script>
import SelectCaseCard from '@/UI/SelectCase/SelectCaseCard.vue';
import { casesLib } from '@/Constants/casesLib';

export default {
    name: 'SelectCaseCategory',
    components: {
        SelectCaseCard,
    },
    props: [
        'categoryId',
        'categoryName',
        'categoryDescription',
        'caseDataArr',
    ],
    computed: {
        casesByCategory() {
            return [ ...casesLib.filter(item => item.categoryId === this.categoryId) ];
        },
    },
    data() {
        return {
            demoItem: {
                id: '11093d48-4a22-45af-8580-de33ca9126f2',
                name: 'Шкаф инструментальный TC-1995',
                minPrice: '28600',
                props: [
                    '1900x950x500',
                    'Регулируемые полки',
                    'До 500 кг',
                    'Сборно-разборный',
                ],
            },
        };
    },
};
</script>

<style scoped lang="scss">
.tc-select-case-category-label {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    height: max-content;
}

.tc-select-case-category-label-bold {
    font-weight: 600;
    font-size: 20px;
}

.tc-select-case-category-label-normal {
    font-size: 14px;
}

.tc-select-case-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    width: 100%;
    box-sizing: border-box;
}
</style>
